import React from 'react';
import PropTypes from 'prop-types';

import {Dropdown, DropdownMenuItem} from 'views/components';
import {translate} from 'views/module';

import CompactDropdown from './CompactDropdown';

const LeadQualityDropdown = (props) => {
  const {selectedLeadQuality, setSelectedLeadQuality} = props;

  const leadQualityOptions = Object.entries(translate('client.LeadQuality'));
  const variant = props.variant || 'default';
  const isCompact = variant === 'compact';
  const dropdownValue = selectedLeadQuality || 'NONE';
  const dropdownTitle = translate(`client.LeadQuality.${dropdownValue}.Title`);
  const dropdownColor = translate(`client.LeadQuality.${dropdownValue}.Color`);

  const handleOptionSelect = (optionKey) => {
    if (optionKey) {
      setSelectedLeadQuality(optionKey);
    }
  };

  return (
    <>
      {
        isCompact &&
        <CompactDropdown
          getOptionKey={([key]) => key}
          getOptionLabel={([, value]) => value.Title}
          isOptionSelected={([key]) => dropdownValue === key}
          label={props.label}
          menuLabel={props.label}
          onOptionSelect={([key]) => handleOptionSelect(key)}
          options={leadQualityOptions}
          value={dropdownTitle}
          valueColor={dropdownColor}
        />
      }
      {
        !isCompact &&
        <Dropdown
          onChange={handleOptionSelect}
          value={dropdownValue}
          label={translate('client.ClientDetail.Status.Menu.Subtitles.LeadQuality')}
          valueColor={dropdownColor}
        >
          {
            leadQualityOptions.map(([k, v]) => {
              return (
                <DropdownMenuItem key={k} value={k}>{v.Title}</DropdownMenuItem>
              );
            })
          }
        </Dropdown>
      }
    </>
  );
};

LeadQualityDropdown.propTypes = {
  label: PropTypes.string,
  selectedLeadQuality: PropTypes.string,
  setSelectedLeadQuality: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'compact']),
};

export default LeadQualityDropdown;
